import { Component, ViewChild, ElementRef } from '@angular/core';

import { CommonService, DataExportExt } from '../../services/common.service';
import { ReportsService } from '../../services/reports.service';

@Component({
  selector: 'vrm-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  searchBorderColor?: string;

  @ViewChild('pageHeaderSearchInput') pageHeaderSearchInput: ElementRef<HTMLInputElement>;

  constructor(public rptService: ReportsService, public cService: CommonService) {
    this.toggleSearchBorderColor(true);
  }

  private toggleSearchBorderColor(applyColor: boolean) {
    if (applyColor && this.cService.userProfile && this.cService.userProfile.HqColour) {
      this.searchBorderColor = '#' + this.cService.userProfile.HqColour;
    } else {
      this.searchBorderColor = '';
    }
  }

  toggleSearchActivation() {
    this.rptService.gridSearch.activated = !this.rptService.gridSearch.activated;

    if (this.rptService.gridSearch.activated) {
      setTimeout(() => {
        this.pageHeaderSearchInput.nativeElement.focus();
      });
    } else {
      if (this.rptService.gridSearch.text) {
        this.cService.triggerHeaderSearchToggledAsObservable(this.rptService.gridSearch.activated);
      }

      this.rptService.gridSearch.text = '';
    }
  }

  searchInputChanged() {
    this.rptService.gridSearch.activated = this.rptService.gridSearch.text ? true : false;
    this.cService.triggerHeaderSearchInputChangedAsObservable(this.rptService.gridSearch.text);

    if (this.rptService.gridSearch.activated === false) {
      this.cService.triggerHeaderSearchToggledAsObservable(this.rptService.gridSearch.activated);
    }
  }

  emitDownloadEvent(extension: DataExportExt) {
    this.cService.triggerReportDownloadRequestAsObservable(extension);
  }

  closeCurrentTab() {
    window.close();
  }
}
